import Header from "@/components/header";
import Footer from "@/components/footer";
import Head from "next/head";
import MapBackground from "@/components/map-background";
export default function Terms() {
  return (
    <>
      <Head>
        <title>Partbot - Terms of Service</title>
      </Head>
      <Header />
      <main>
        <div className="relative py-24 md:py-40">
          <div className="container mx-auto">
            <div className="prose prose-invert mx-auto max-w-prose px-6 text-sm text-emerald-300/60 md:px-6 md:text-base">
              <h2 className="bg-linear-to-br from-white to-stone-300 bg-clip-text text-3xl font-extrabold tracking-tight text-transparent md:text-5xl">
                Terms of Service
              </h2>
              <h6>Last updated: 13th March 2024</h6>
              <p>
                These Terms of Service govern your use of the website located at{" "}
                <a href="https://partbot.io">https://partbot.io</a> and any
                related services provided by Partbot Software Pty Ltd (Partbot).{" "}
              </p>
              <p>
                By accessing <a href="https://partbot.io">https://partbot.io</a>{" "}
                and any subdomains of partbot.io, you agree to abide by these
                Terms of Service and to comply with all applicable laws and
                regulations. If you do not agree with these Terms of Service,
                you are prohibited from using or accessing this website or using
                any other services provided by Partbot Software Pty Ltd.{" "}
              </p>
              <p>
                We, Partbot Software Pty Ltd, reserve the right to review and
                amend any of these Terms of Service at our sole discretion. Upon
                doing so, we will update this page. Any changes to these Terms
                of Service will take effect immediately from the date of
                publication.{" "}
              </p>
              <p>These Terms of Service were last updated on 5 May 2021. </p>
              <h3>Limitations of Use</h3>
              <p>
                By using this website, you warrant on behalf of yourself, your
                users, and other parties you represent that you will not:{" "}
              </p>
              <ol>
                <li>
                  modify, copy, prepare derivative works of, decompile, or
                  reverse engineer any materials and software contained on this
                  website;
                </li>
                <li>
                  remove any copyright or other proprietary notations from any
                  materials and software on this website;
                </li>
                <li>
                  transfer the materials to another person or
                  &ldquo;mirror&rdquo; the materials on any other server;
                </li>
                <li>
                  knowingly or negligently use this website or any of its
                  associated services in a way that abuses or disrupts our
                  networks or any other service Partbot Software Pty Ltd
                  provides;
                </li>
                <li>
                  use this website or its associated services to transmit or
                  publish any harassing, indecent, obscene, fraudulent, or
                  unlawful material;
                </li>
                <li>
                  use this website or its associated services in violation of
                  any applicable laws or regulations;
                </li>
                <li>
                  use this website in conjunction with sending unauthorised
                  advertising or spam;
                </li>
                <li>
                  harvest, collect or gather user data without the user’s
                  consent; or
                </li>
                <li>
                  use this website or its associated services in such a way that
                  may infringe the privacy, intellectual property rights, or
                  other rights of third parties.
                </li>
              </ol>
              <h3>Intellectual Property</h3>
              <p>
                The intellectual property in the materials contained in this
                website are owned by or licensed to Partbot Software Pty Ltd and
                are protected by applicable copyright and trademark law. We
                grant our users permission to download one copy of the materials
                for personal, non-commercial transitory use.{" "}
              </p>
              <p>
                This constitutes the grant of a license, not a transfer of
                title. This license shall automatically terminate if you violate
                any of these restrictions or the Terms of Service, and may be
                terminated by Partbot Software Pty Ltd at any time.{" "}
              </p>
              <h3>User-Generated Content</h3>
              <p>
                You retain your intellectual property ownership rights over
                content you submit to us for publication on our website. We will
                never claim ownership of your content but we do require a
                license from you in order to use it.{" "}
              </p>
              <p>
                When you use our website or its associated services to post,
                upload, share or otherwise transmit content covered by
                intellectual property rights, you grant to us a non-exclusive,
                royalty-free, transferable, sub-licensable, worldwide license to
                use, distribute, modify, run, copy, publicly display, translate
                or otherwise create derivative works of your content in a manner
                that is consistent with your privacy preferences and our Privacy
                Policy.{" "}
              </p>
              <p>
                The license you grant us can be terminated at any time by
                deleting your content or account. However, to the extent that we
                (or our partners) have used your content in connection with
                commercial or sponsored content, the license will continue until
                the relevant commercial or post has been discontinued by us.{" "}
              </p>
              <p>
                You give us permission to use your username and other
                identifying information associated with your account in a manner
                that is consistent with your privacy preferences and our Privacy
                Policy.{" "}
              </p>
              <h3>Liability</h3>
              <p>
                Our website and the materials on our website are provided on an
                'as is' basis. To the extent permitted by law, Partbot Software
                Pty Ltd makes no warranties, expressed or implied, and hereby
                disclaims and negates all other warranties including, without
                limitation, implied warranties or conditions of merchantability,
                fitness for a particular purpose, or non-infringement of
                intellectual property, or other violation of rights.{" "}
              </p>
              <p>
                In no event shall Partbot Software Pty Ltd or its suppliers be
                liable for any consequential loss suffered or incurred by you or
                any third party arising from the use or inability to use this
                website or the materials on this website, even if SWD Aust Pty
                Ltd or an authorised representative has been notified, orally or
                in writing, of the possibility of such damage.{" "}
              </p>
              <p>
                In the context of this agreement, &ldquo;consequential
                loss&rdquo; includes any consequential loss, indirect loss, real
                or anticipated loss of profit, loss of benefit, loss of revenue,
                loss of business, loss of goodwill, loss of opportunity, loss of
                savings, loss of reputation, loss of use and/or loss or
                corruption of data, whether under statute, contract, equity,
                tort (including negligence), indemnity or otherwise.{" "}
              </p>
              <p>
                Because some jurisdictions do not allow limitations on implied
                warranties, or limitations of liability for consequential or
                incidental damages, these limitations may not apply to you.{" "}
              </p>
              <h3>Accuracy of Materials</h3>
              <p>
                The materials appearing on our website are not comprehensive and
                are for general information purposes only. Partbot Software Pty
                Ltd does not warrant or make any representations concerning the
                accuracy, likely results, or reliability of the use of the
                materials on this website, or otherwise relating to such
                materials or on any resources linked to this website.{" "}
              </p>
              <h3>Links</h3>
              <p>
                Partbot Software Pty Ltd has not reviewed all of the sites
                linked to its website and is not responsible for the contents of
                any such linked site. The inclusion of any link does not imply
                endorsement, approval or control by Partbot Software Pty Ltd of
                the site. Use of any such linked site is at your own risk and we
                strongly advise you make your own investigations with respect to
                the suitability of those sites.{" "}
              </p>
              <h3>reCAPTCHA</h3>
              <p>
                This website uses Google reCAPTCHA to protect against spam,
                abuse, and automated attacks. reCAPTCHA collects hardware and
                software information, such as device and application data, and
                sends this data to Google for analysis. Your use of reCAPTCHA is
                subject to Google's{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-emerald-400 hover:text-emerald-300"
                >
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-emerald-400 hover:text-emerald-300"
                >
                  Terms of Service
                </a>
                . By using our website and submitting forms, you acknowledge and
                agree to Google's collection and use of information as described
                in their policies.{" "}
              </p>
              <h3>Right to Terminate</h3>
              <p>
                We may suspend or terminate your right to use our website and
                terminate these Terms of Service immediately upon written notice
                to you for any breach of these Terms of Service.{" "}
              </p>
              <h3>Severance</h3>
              <p>
                Any term of these Terms of Service which is wholly or partially
                void or unenforceable is severed to the extent that it is void
                or unenforceable. The validity of the remainder of these Terms
                of Service is not affected.{" "}
              </p>
              <h3>Governing Law</h3>
              <p>
                These Terms of Service are governed by and construed in
                accordance with the laws of Queensland, Australia. You
                irrevocably submit to the exclusive jurisdiction of the courts
                in that State or location.{" "}
              </p>
              <h3 id="tecalliance-copyright" className="scroll-mt-52">
                TecAlliance (TecDoc) Copyright Notice
              </h3>
              <p>
                The data shown here, especially the complete database, may not
                be copied. It is strictly prohibited to duplicate the data and
                database and distribute the same, and/or instruct third parties
                to engage in such activities, without prior consent from
                TecAlliance. Any use of content in a manner not expressly
                authorized constitutes copyright infringement and violators will
                be prosecuted.
              </p>
              <h3>Professional Services</h3>
              <p>
                Partbot may be engaged by an existing customer to complete
                custom software development, platform integrations, data
                processing, management and other bespoke projects, known herein
                as 'Professional Services'.
              </p>

              <p>
                Limitation of Liability: Partbot, including its directors,
                employees, subcontractors, agents, and affiliates, shall not be
                liable for any indirect, incidental, special, consequential, or
                punitive damages, including without limitation, losses of
                profits, data, revenue, goodwill, or other intangible losses,
                arising out of or in connection with the use of, or the
                inability to use, the Professional Services. This limitation
                applies whether the alleged liability is based on contract,
                tort, negligence, strict liability, or any other basis, even if
                Partbot has been advised of the possibility of such damage. The
                foregoing limitation of liability shall apply to the fullest
                extent permitted by law in the applicable jurisdiction.
              </p>

              <p>
                Warranty Disclaimer: The Professional Services, including all
                related software, documentation, and any other materials
                provided under these terms, are provided "AS IS" and "AS
                AVAILABLE," with all faults and without warranty of any kind.
                Partbot and its subcontractors expressly disclaim all
                warranties, whether express, implied, statutory, or otherwise,
                including, without limitation, any warranties of
                merchantability, fitness for a particular purpose, and
                non-infringement. Partbot does not warrant that the Professional
                Services will meet your requirements or that the operation of
                the Professional Services will be uninterrupted or error-free.
              </p>

              <p>
                Indemnification: You agree to defend, indemnify, and hold
                harmless Partbot, its officers, directors, employees,
                subcontractors, and agents from and against any claims, actions,
                demands, liabilities, judgements, and settlements, including
                without limitation, reasonable legal and accounting fees,
                resulting from, or alleged to result from, your use of the
                Professional Services or your breach of these Terms of Service.
              </p>

              <p>
                Modifications to Service: Partbot reserves the right, at its
                sole discretion, to modify, suspend, or discontinue the
                Professional Services (or any part thereof) at any time with or
                without notice to you. Partbot will not be liable to you or to
                any third party for any modification, suspension, or
                discontinuance of the Professional Services.
              </p>

              <p>
                Subcontractors: Partbot may, at its discretion, employ the use
                of subcontractors to perform all or part of the services
                provided under these Terms of Service. Partbot shall be
                responsible for the direction, supervision, and compensation of
                its subcontractors in the performance of such services. The
                engagement of subcontractors shall not relieve Partbot of its
                obligations under these Terms of Service or any applicable laws.
                You are not authorized to engage with or employ any
                subcontractor of Partbot.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
